import { render, staticRenderFns } from "./QuotePreview.vue?vue&type=template&id=103661de"
import script from "./QuotePreview.vue?vue&type=script&lang=ts"
export * from "./QuotePreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('103661de')) {
      api.createRecord('103661de', component.options)
    } else {
      api.reload('103661de', component.options)
    }
    module.hot.accept("./QuotePreview.vue?vue&type=template&id=103661de", function () {
      api.rerender('103661de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/leads/QuotePreview.vue"
export default component.exports